//Core modules
import React from 'react';

//Internal modules
import {SettingsProvider} from "./context/settingsContext";
import SettingsWrapper from "./SettingsWrapper";


const Settings = (props) => {

    return (
        <>
            <SettingsProvider>
                <SettingsWrapper {...props} />
            </SettingsProvider>
        </>
    )
}

export default Settings;